<template>
    <article id="legal-document">
        <div id="headline"><a href="/"><img class="logo" src="/static/mixsii-logo.svg"/></a></div>
        <section id="content">
            <router-view></router-view>
        </section>
    </article>
</template>

<script>

    import HomePage from '@/HomePage/HomePage.vue';

    export default {
        name: 'HomeLayout',
        components: {
            'home-page': HomePage
        }
    }
</script>


// WEBPACK FOOTER //
// LegalDocumentLayout.vue?167c333e